import { FEATURES } from 'appConstants';
import useTenantConfigPending from 'containers/Intelligence/useTenantConfigPending';
import {
  CI_ROOT,
  CIActionVerb
} from 'containers/Setting/components/RoleFormModal/customerIntelligence';
import { useFeatureFlags, usePermissions } from 'hooks';

export type OrbitAccess = 'loading' | 'allowed' | 'denied';

export const ORBIT_PERMISSION = `${CI_ROOT}.ai_assistant`;
export const ORBIT_ACTION: CIActionVerb = 'use';

/**
 * Whether the launcher may mount at all. Stays `loading` until both the permission slice and the
 * tenant config have resolved so the launcher is never flashed for a role that turns out to lack the
 * grant. PLA-8844.
 */
export const useOrbitAccess = (): OrbitAccess => {
  const flags = useFeatureFlags();
  const tenantPending = useTenantConfigPending();
  const { loading, actions } = usePermissions(ORBIT_PERMISSION);

  if (loading || tenantPending) {
    return 'loading';
  }

  // Orbit answers to its own flag only, never to `intelligence_suite`; `useFeatureFlags` has already
  // masked it under the `perx_ai_workspace` master. PLA-9754.
  // TODO(AF-6): an absent flag is treated as off; the default for tenants without the flag is pending.
  const assistantEnabled = flags[FEATURES.AI_ASSISTANT.key] === true;

  return assistantEnabled && actions.includes(ORBIT_ACTION) ? 'allowed' : 'denied';
};

export default useOrbitAccess;
